import React, { useEffect, useState } from 'react';
import { post } from '../../Auths/AuthToken';
import FutureAppListRow from './FutureAppListRow';
import { useSelector } from 'react-redux';
import setUiMessage from '../../../Utilities/Tostify';

function PastAppListPopup({
  patientId,
  setPastAppListPopup,
  hideFutreApp = false,
}) {
  const { user } = useSelector((state) => state.auth);
  const [allData, setAllData] = useState(null);
  const [activePastTab, setActivePastTab] = useState(true);
  const [activeFutureTab, setActiveFutureTab] = useState(false);
  const [futureAppList, setFutureAppList] = useState(null);
  const [pastAppList, setPastAppList] = useState(null);
  const [reload, setReload] = useState(false);

  useEffect(() => {
    (async () => {
      try {
        const response = await post(
          'api/appointment/Appointment/getPastAppointmentList',
          {
            patientId: patientId,
            loginUserId: user?.id,
          }
        );

        if (response?.status === 200) {
          setAllData(response?.data);
          setFutureAppList(response?.data?.futAppList);
          setPastAppList(response?.data?.pastEncList);
        }
      } catch (err) {
        setUiMessage('err', err.message);
      }
    })();
  }, [patientId, user?.id, reload]);

  const handlePastAvtiveTab = () => {
    setActivePastTab(true);
    setActiveFutureTab(false);
  };
  const handleFutureAvtiveTab = () => {
    setActivePastTab(false);
    setActiveFutureTab(true);
  };
  return (
    <div className="modalBackground" style={{ zIndex: '15' }}>
      <div
        className="main-contnr"
        style={{
          zIndex: '30',
          padding: '0px 15px 15px 15px',
          width: '60%',
        }}
      >
        <div className="appt-hx-hdr-pt-info">
          <span className="rc-pt-nm">
            {allData?.patientFullName} <span className="red">|</span> ID:
            {allData?.chartNo}
            <span className="red"> | </span> {allData?.patYearGen}
            <span className="red"> | </span> Dob:{allData?.dob}
          </span>
          <span
            className="right red bold"
            onClick={() => setPastAppListPopup(false)}
          >
            X
          </span>
        </div>
        <div className="appt-hx-hdr tab-bg">
          <span
            className={
              activePastTab
                ? 'menu-item menu-item-active'
                : 'menu-item link-color'
            }
            onClick={handlePastAvtiveTab}
          >
            Past Encounters
          </span>
          {!hideFutreApp && (
            <span
              className={
                activeFutureTab
                  ? 'menu-item menu-item-active'
                  : 'menu-item link-color'
              }
              onClick={handleFutureAvtiveTab}
            >
              Future Appointments
            </span>
          )}
        </div>
        <div
          className={activePastTab ? 'appt-hx-pc-body' : 'appt-hx-pc-body hide'}
        >
          {pastAppList &&
            pastAppList.map((item, idx) => {
              return (
                <div
                  key={idx}
                  className={idx % 2 === 0 ? 'appt-hx-rw alt-rw' : 'appt-hx-rw'}
                >
                  <div className="appt-hx-ch-rw orange-txt">
                    <span className="">
                      {item?.dov} {item?.visitTime}
                    </span>
                    <span className="red"> | </span>
                    <span className="">{item?.tov}</span>
                    <span className="red"> | </span>
                    <span className="">
                      {item?.provider} / {item?.resource}
                    </span>
                  </div>
                  {item?.statusWithNote ? (
                    <div className="appt-hx-srvc-rw">
                      {item?.statusWithNote}
                    </div>
                  ) : (
                    <div className="appt-hx-srvc-rw">
                      <span className="srvc-code">{item?.enmDetail}</span>
                      <span className="sec-colr">{item?.dxStr}</span>

                      {item?.labArr &&
                        item?.labArr.map((item, idx) => {
                          return (
                            <span key={idx}>
                              <span className="sep">&nbsp;</span>
                              <span className="srvc-code">{item?.cpt}</span>
                              <span className="sec-colr">{item?.labDxStr}</span>
                            </span>
                          );
                        })}
                    </div>
                  )}
                </div>
              );
            })}
        </div>
        <div
          className={
            activeFutureTab ? 'appt-hx-fa-body' : 'appt-hx-fa-body hide'
          }
        >
          <div className="appt-hx-fa-hdr">
            <span className="ahfh-lbl-2">Date</span>
            <span className="ahfh-lbl-1">Visit</span>
            <span className="ahfh-lbl-4">Provider</span>
            <span className="ahfh-lbl-3">Action</span>
          </div>
          <div className="appt-hx-fa-inr-body">
            {futureAppList &&
              futureAppList.map((item, idx) => {
                return (
                  <div
                    key={idx}
                    className={
                      idx % 2 === 0 ? 'appt-hx-fa-rw alt-rw' : 'appt-hx-fa-rw'
                    }
                  >
                    <FutureAppListRow
                      data={item}
                      reload={() => setReload(!reload)}
                    />
                  </div>
                );
              })}
          </div>
        </div>
      </div>
    </div>
  );
}

export default PastAppListPopup;
